"use client";

import { useState } from "react";
import { useDealerVehicleMarket } from "@/context/DealerVehicleMarketProvider";
import "./DealerFeeBanner.css";

export default function DealerFeeBanner() {
  const { buyerFeeAmount } = useDealerVehicleMarket();
  const [dismissed, setDismissed] = useState(false);

  // Use the same central fee switch as the vehicle badge.
  if (buyerFeeAmount !== 0 || dismissed) return null;

  return (
    <aside className="Dealer-fee-banner" aria-label="Gebühren für Händlerfahrzeuge">
      <p className="Dealer-fee-banner-text">
        <strong>0 € Gebühren</strong> beim Kauf von Händlerfahrzeugen
      </p>
      <button
        type="button"
        className="Dealer-fee-banner-close"
        aria-label="Gebührenhinweis schließen"
        onClick={() => setDismissed(true)}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="m6 6 12 12M18 6 6 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      </button>
    </aside>
  );
}
